import React from 'react';
import * as FlexWebChat from '@twilio/flex-webchat-ui';
import Locales from '../locales';

const translations = Locales.getTranslations();

export class MessageCanvasTray extends React.Component {
  
  componentDidMount() {
    localStorage.setItem('flapperChatStage', 'CLOSED_BY_AGENT');
  }

  handleOnClick() {
    localStorage.setItem('flapperChatStage', 'INITIALIZING');
    //console.log(localStorage)
    FlexWebChat.Actions.invokeAction("RestartEngagement");
  }

  render() {
    return (
      <div className="Flapper-MessageCanvasTray">
        <h1>{translations['custom.messageCanvasTrayTitle']}</h1>
        <h3>{translations['custom.messageCanvasTraySubtitle']}</h3>
        <div className="Flapper-MessageCanvasTray-button" onClick={this.handleOnClick}>{translations["custom.messageCanvasTrayButton"]}</div>
      </div>
    )
  }
}
